<ng-container *ngIf="role && role !== 'MODERATOR'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as CUSTOMER, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>

<ng-container *ngIf="role && role === 'MODERATOR'">
  <div class="wrapper">

    <div style="font-size: large;">
      <div style="display: inline-block;">
        <span class="green">User Type: </span>
      </div>
      <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="CUSTOMER" (change)="changeUser($event)" required>CUSTOMER</mat-radio-button>
        <mat-radio-button value="TECHEXPERT" (change)="changeUser($event)" required>TECH EXPERT</mat-radio-button>
      </mat-radio-group>
    </div>
    <h1 style="font-weight: bold; background-color: rgb(30, 0, 85); color:white; text-align: center;"><b>{{userType}}</b> Sign Up</h1>





    <div id="custForm" *ngIf="userType === 'CUSTOMER'">
      <form  class="container" [formGroup]="customerForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <div id="left">
            <label>
              <h2>User Name</h2>
            </label>
          </div>
          <div id="right">
            <input type="text" formControlName="userName">
            <mat-error *ngIf="customerForm.controls['userName'].invalid && customerForm.controls['userName'].errors.required"> User Name Required </mat-error>
          </div>
        </div>
          <br>
        <div class="form-row">
          <div id="left"><label><h2>Full Name</h2></label></div>
          <div id="right"><input type="text" formControlName="fullName">
            <mat-error *ngIf="customerForm.controls['fullName'].invalid && customerForm.controls['fullName'].errors.required">Full Name Required</mat-error>
          </div>
        </div>
          <br>
        <div class="form-row">
          <div id="left"><label><h2>Email</h2></label></div>
          <div id="right"><input type="text" formControlName="email">
          <mat-error *ngIf="customerForm.controls['email'].invalid && customerForm.controls['email'].errors.required">Email is Required</mat-error>
          <mat-error *ngIf="customerForm.controls['email'].invalid && customerForm.controls['email'].errors.email">Email Invalid</mat-error>
          </div>
        </div>
          <br>
          <div class="form-row">
            <div id="left"><label><h2>Primary Email</h2></label></div>
            <div id="right"><input type="text" formControlName="pEmail">
            <mat-error *ngIf="customerForm.controls['pEmail'].invalid && customerForm.controls['pEmail'].errors.required">Email is Required</mat-error>
            <mat-error *ngIf="customerForm.controls['pEmail'].invalid && customerForm.controls['pEmail'].errors.email">Email Invalid</mat-error>
            </div>
          </div>
            <br>
        <div class="form-row">
          <div id="left"><label><h2>Contact Number</h2></label></div>
          <div id="right"><input type="text" formControlName="contactNumber">
          <mat-error *ngIf="customerForm.controls['contactNumber'].invalid && customerForm.controls['contactNumber'].errors.required">Contact Number is Required</mat-error>
          <mat-error *ngIf="customerForm.controls['contactNumber'].invalid && (customerForm.controls['contactNumber'].errors.minlength || customerForm.controls['contactNumber'].errors.maxlength)">contactNumber must be 10 characters</mat-error></div>
        </div>
        <br>
        <div class="form-row">
          <div id="left"><label><h2>Primary Contact Number</h2></label></div>
          <div id="right"><input type="text" formControlName="pContactNumber">
          <mat-error *ngIf="customerForm.controls['pContactNumber'].invalid && customerForm.controls['pContactNumber'].errors.required">Contact Number is Required</mat-error>
          <mat-error *ngIf="customerForm.controls['pContactNumber'].invalid && (customerForm.controls['pContactNumber'].errors.minlength || customerForm.controls['pContactNumber'].errors.maxlength)">contactNumber must be 10 characters</mat-error></div>
        </div>
        <br>
        <div class="form-row">
          <div id="left">
            <label>
              <h2>Company Name</h2>
            </label>
          </div>
          <div id="right">
            <input type="text" formControlName="companyName">
            <mat-error *ngIf="customerForm.controls['companyName'].invalid && customerForm.controls['companyName'].errors.required"> Company Name Required </mat-error>
          </div>
        </div>


        <!--BANKING DETAILS-->
        <br>
         <h1 style="font-weight: bold; background-color: rgb(30, 0, 85); color:white; text-align: center;">Enter Bank Details</h1>
      
      <div class="form-row">
        <div id="left">
          <label>
            <h2>GST Number</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="gstNumber">
          <br>
          <mat-error *ngIf="customerForm.controls['gstNumber'].invalid && customerForm.controls['gstNumber'].errors.required"> GST Number Required </mat-error>
          <mat-error *ngIf="customerForm.controls['gstNumber'].invalid && (customerForm.controls['gstNumber'].errors.minlength || customerForm.controls['gstNumber'].errors.maxlength)"> Length should be 15 </mat-error>
        </div>
      </div>
      <br>
      
      <div class="form-row">
        <div id="left">
          <label>
            <h2>PAN</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="PAN">
          <br>
          <mat-error *ngIf="customerForm.controls['PAN'].invalid && customerForm.controls['PAN'].errors.required"> PAN Required </mat-error>
          <mat-error *ngIf="customerForm.controls['PAN'].invalid && (customerForm.controls['PAN'].errors.minlength || customerForm.controls['PAN'].errors.maxlength)"> Length should be 10 </mat-error>
        </div>
      </div>
      <br>
      
      <div class="form-row">
        <div id="left">
          <label>
            <h2>Currency</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="currency">
          <br>
          <mat-error *ngIf="customerForm.controls['currency'].invalid && customerForm.controls['currency'].errors.required"> Currency Required </mat-error>
        </div>
      </div>
      <br>
      
      <div class="form-row">
        <div id="left">
          <label>
            <h2>Bank Name</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="bankName">
          <br>
          <mat-error *ngIf="customerForm.controls['bankName'].invalid && customerForm.controls['bankName'].errors.required"> Bank Name Required </mat-error>
        </div>
      </div>
      <br>
      
      <div class="form-row">
        <div id="left">
          <label>
            <h2>Bank Account Number</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="bankAccountNumber">
          <br>
          <mat-error *ngIf="customerForm.controls['bankAccountNumber'].invalid && customerForm.controls['bankAccountNumber'].errors.required"> Bank Account Required </mat-error>
        </div>
      </div>
      <br>
     
      <div class="form-row">
        <div id="left">
          <label>
            <h2>IFSC</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="IFSC">
          <br>
          <mat-error *ngIf="customerForm.controls['IFSC'].invalid && customerForm.controls['IFSC'].errors.required"> IFSC Required </mat-error>
          <mat-error *ngIf="customerForm.controls['IFSC'].invalid && (customerForm.controls['IFSC'].errors.minlength || customerForm.controls['IFSC'].errors.maxlength)"> Length should be 11 </mat-error>
        </div>
      </div>
      <br>
      
      <div class="form-row">
        <div id="left">
          <label>
            <h2>SWIFT</h2>
          </label>
        </div>
        <div id="right">
          <input type="text" formControlName="SWIFT">
          <br>
          <mat-error *ngIf="customerForm.controls['SWIFT'].invalid && customerForm.controls['SWIFT'].errors.required"> SWIFT Required </mat-error>
          <mat-error *ngIf="customerForm.controls['SWIFT'].invalid && (customerForm.controls['SWIFT'].errors.minlength || customerForm.controls['SWIFT'].errors.maxlength)"> Length should be 11 </mat-error>
        </div>
      </div>
      <br>



        <button  id ="signup" type="submit" class="btn" [disabled]="customerForm.invalid">SUBMIT</button>
        <mat-error *ngIf="serverErrorMessages">{{serverErrorMessages}}</mat-error>
      </form>
    </div>













    <div id="custForm" *ngIf="userType === 'TECHEXPERT'">
      <form class="container" [formGroup]="techExpertForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <div id="left">
            <label>
              <h2>User Name</h2>
            </label>
          </div>
          <div id="right">
            <input type="text" formControlName="userName">
            <mat-error *ngIf="techExpertForm.controls['userName'].invalid && techExpertForm.controls['userName'].errors.required"> User Name Required </mat-error>
          </div>
        </div>
          <br>
        <div class="form-row">
          <div id="left"><label><h2>Full Name</h2></label></div>
          <div id="right"><input type="text" formControlName="fullName">
            <mat-error *ngIf="techExpertForm.controls['fullName'].invalid && techExpertForm.controls['fullName'].errors.required">Full Name Required</mat-error>
          </div>
        </div>
          <br>
        <div class="form-row">
          <div id="left"><label><h2>Email</h2></label></div>
          <div id="right"><input type="text" formControlName="email">
          <mat-error *ngIf="techExpertForm.controls['email'].invalid && techExpertForm.controls['email'].errors.required">Email is Required</mat-error>
          <mat-error *ngIf="techExpertForm.controls['email'].invalid && techExpertForm.controls['email'].errors.email">Email Invalid</mat-error>
          </div>
        </div>
          <br>
        <div class="form-row">
          <div id="left"><label><h2>Contact Number</h2></label></div>
          <div id="right"><input type="text" formControlName="contactNumber">
          <mat-error *ngIf="techExpertForm.controls['contactNumber'].invalid && techExpertForm.controls['contactNumber'].errors.required">Contact Number is Required</mat-error>
          <mat-error *ngIf="techExpertForm.controls['contactNumber'].invalid && (techExpertForm.controls['contactNumber'].errors.minlength || techExpertForm.controls['contactNumber'].errors.maxlength)">contactNumber must be 10 characters</mat-error></div>
        </div>
        <button id ="signup" type="submit" class="btn">SUBMIT</button>
        <mat-error *ngIf="serverErrorMessages">{{serverErrorMessages}}</mat-error>
      </form>
    </div>

  </div>
</ng-container>
